import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";
const HEADER_HIGHLIGHT = "rgba(6, 182, 164, 0.08)";

const DAYS_CHANGE_DATA = [
  { scheme: "NSE Nifty 50", change: "0.07", nav: "25953.8500", date: "11-02-2026" },
  { scheme: "BSE Sensex", change: "-0.05", nav: "84233.6400", date: "11-02-2026" },
];

const DAYS_HEADERS = [
  { key: "scheme", label: "Schemes/Shares", sort: true, search: true },
  { key: "change", label: "Change (%)", sort: true, highlight: true },
  { key: "nav", label: "NAV/Price", sort: true },
  { key: "date", label: "Date", sort: true },
];

const HISTORICAL_HEADERS = [
  { key: "schemes", label: "Schemes", sort: true, search: true },
  { key: "nav", label: "NAV", sort: true },
  { key: "category", label: "Category", sort: true, search: true },
  { key: "currentValue", label: "Current Value", sort: true },
  { key: "allocation", label: "Allocation (%)", sort: true },
  { key: "1m", label: "1 Month", sort: true },
  { key: "3m", label: "3 Month", sort: true },
  { key: "6m", label: "6 Month", sort: true },
  { key: "1y", label: "1 Year", sort: true, highlight: true },
  { key: "2y", label: "2 Year", sort: true },
  { key: "3y", label: "3 Year", sort: true },
  { key: "5y", label: "5 Year", sort: true },
  { key: "10y", label: "10 Year", sort: true },
  { key: "15y", label: "15 Year", sort: true },
  { key: "20y", label: "20 Year", sort: true },
  { key: "launchDate", label: "Launch Date", sort: true },
  { key: "sinceInception", label: "Since Inception", sort: true },
];

const thStyle = (highlight) => ({
  padding: "12px 16px",
  color: "#475569",
  fontWeight: "600",
  fontSize: "13px",
  whiteSpace: "nowrap",
  background: highlight ? HEADER_HIGHLIGHT : "#f8fafc",
  borderLeft: highlight ? `2px solid ${TEAL}` : undefined,
  borderRight: highlight ? `2px solid ${TEAL}` : undefined,
});

export default function Watchlist() {
  const [tab, setTab] = useState("days"); // "days" | "historical"
  const [lumpsumReturns, setLumpsumReturns] = useState(true); // true = Lumpsum, false = SIP
  const [rowsVisible, setRowsVisible] = useState(2);

  const handleExport = () => {
    // TODO: export to XLS
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <h3 className="text-primary mb-2">Watchlist</h3>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">Watchlist</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Tabs */}
        <div
          className="d-flex border-bottom"
          style={{
            gap: 0,
            borderColor: "#e2e8f0",
            marginBottom: "1rem",
          }}
        >
          <button
            type="button"
            className="watchlist-tab"
            style={{
              background: "transparent",
              border: "none",
              borderBottom: tab === "days" ? `3px solid ${TEAL}` : "3px solid transparent",
              color: tab === "days" ? TEAL : "#64748b",
              fontWeight: "600",
              fontSize: "15px",
              padding: "12px 20px",
              marginBottom: "-1px",
              cursor: "pointer",
              transition: "color 0.2s, border-color 0.2s",
            }}
            onClick={() => setTab("days")}
          >
            Days Change
          </button>
          <button
            type="button"
            className="watchlist-tab"
            style={{
              background: "transparent",
              border: "none",
              borderBottom: tab === "historical" ? `3px solid ${TEAL}` : "3px solid transparent",
              color: tab === "historical" ? TEAL : "#64748b",
              fontWeight: "600",
              fontSize: "15px",
              padding: "12px 20px",
              marginBottom: "-1px",
              cursor: "pointer",
              transition: "color 0.2s, border-color 0.2s",
            }}
            onClick={() => setTab("historical")}
          >
            Historical Change
          </button>
        </div>

        {/* Historical: info + toggle + export row */}
        {tab === "historical" && (
          <div className="card shadow-sm border-0 mb-3" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
            <div className="card-body py-3 px-4 d-flex flex-wrap align-items-center justify-content-between gap-3">
              <p className="mb-0 text-muted small" style={{ fontSize: "13px" }}>
                Returns less than 1 year are absolute return and more than 1 year are annualized.
              </p>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <span className="small" style={{ color: "#475569" }}>SIP Returns</span>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={lumpsumReturns}
                    onClick={() => setLumpsumReturns(!lumpsumReturns)}
                    style={{
                      width: 44,
                      height: 24,
                      borderRadius: 12,
                      border: "none",
                      background: lumpsumReturns ? TEAL : "#cbd5e1",
                      position: "relative",
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: 2,
                        left: lumpsumReturns ? 22 : 2,
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        background: "#fff",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                      }}
                    />
                  </button>
                  <span className="small" style={{ color: "#475569" }}>Lumpsum Returns</span>
                </div>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                  onClick={handleExport}
                  title="Export XLS"
                >
                  <i className="fa fa-file-excel-o" style={{ color: "#217346" }} aria-hidden /> XLS
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Table card */}
        <div className="card shadow-sm border-0 mb-4 position-relative" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          {tab === "days" && (
            <div className="position-absolute top-0 end-0 m-3" style={{ zIndex: 1 }}>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                onClick={handleExport}
                title="Export XLS"
              >
                <i className="fa fa-file-excel-o" style={{ color: "#217346" }} aria-hidden /> XLS
              </button>
            </div>
          )}

          {tab === "days" ? (
            <>
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      {DAYS_HEADERS.map((h) => (
                        <th key={h.key} style={thStyle(h.highlight)}>
                          {h.label}
                          {h.sort && <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />}
                          {h.search && <i className="fa fa-search ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ background: "#fff" }}>
                    {DAYS_CHANGE_DATA.map((row, idx) => (
                      <tr key={row.scheme} style={{ background: idx % 2 === 1 ? "#f8fafc" : "#fff" }}>
                        <td style={{ padding: "12px 16px", color: TEAL, fontWeight: "500" }}>{row.scheme}</td>
                        <td style={{ padding: "12px 16px", color: "#475569" }}>{row.change}</td>
                        <td style={{ padding: "12px 16px", color: "#475569" }}>{row.nav}</td>
                        <td style={{ padding: "12px 16px", color: "#475569" }}>{row.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center px-4 py-3" style={{ background: "#f8fafc", borderTop: "1px solid #e2e8f0" }}>
                <div className="d-flex align-items-center gap-2">
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 60 }}
                    value={rowsVisible}
                    onChange={(e) => setRowsVisible(Number(e.target.value))}
                  >
                    <option value={2}>2</option>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>
                  <span className="small text-muted">rows visible out of {DAYS_CHANGE_DATA.length}.</span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      {HISTORICAL_HEADERS.map((h) => (
                        <th key={h.key} style={thStyle(h.highlight)}>
                          {h.label}
                          {h.sort && <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />}
                          {h.search && <i className="fa fa-search ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ background: "#fff", minHeight: 120 }}>
                    <tr>
                      <td colSpan={HISTORICAL_HEADERS.length} className="text-center py-5">
                        <div className="d-flex flex-column align-items-center justify-content-center text-muted">
                          <i className="fa fa-exclamation-triangle mb-2" style={{ fontSize: "28px", color: "#f59e0b" }} aria-hidden />
                          <span style={{ fontSize: "15px" }}>No data available.</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>

        {/* FAB - Days Change view */}
        {tab === "days" && (
          <div className="position-fixed bottom-0 end-0 m-4" style={{ zIndex: 100 }}>
            <button
              type="button"
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow"
              style={{
                width: 56,
                height: 56,
                background: TEAL,
                color: "#fff",
                border: "none",
                fontWeight: "700",
                fontSize: "18px",
              }}
              title="Add to watchlist"
            >
              1
            </button>
          </div>
        )}
      </div>

      <style>{`
        .watchlist-tab:hover { color: #0d9488 !important; }
        .watchlist-tab:focus { outline: none; box-shadow: none; }
      `}</style>
    </>
  );
}
